import { DataListType } from '@/types/data-lists'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<DataListType>({
  pathCategory: 'languages',
})

export function useGetLanguage({
  id,
  ...options
}: UseGetDetailOptions<DataListType>) {
  const query = useGetDetail<DataListType>({
    id,
    queryKey: queryKeys.languages.detail({ id, filters: options.filters }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    language: query.data,
    ...query,
  }
}

export function useGetLanguages({
  filters,
  ...options
}: UseGetListOptions<DataListType> = {}) {
  const query = useGetList<DataListType>({
    filters,
    queryKey: queryKeys.languages.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    languages: query.allData,
    ...query,
  }
}
